import * as React from 'react';
import tokeniser from 'sbd';
/**
 * Breaks the text into paragraphs.
 * **/
export function useParagrapher(copy?: string) {
  const paragraphs = React.useMemo(() => {
    if (typeof copy === 'undefined') return [];
    const sentences: string[] = tokeniser.sentences(copy);
    return sentences.reduce((acc, sentence, index) => {
      if ((index + 1) % 4) {
        if (typeof acc[acc.length - 1] === 'string') {
          acc[acc.length - 1] += ` ${sentence}`;
          return acc;
        } else {
          return acc.concat(sentence);
        }
      } else {
        return acc.concat(sentence);
      }
    }, [] as string[]);
  }, [copy]);
  return paragraphs;
}
